import { takeLatest, put } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  cancelOrderFail,
  cancelOrderRequest, cancelOrderSuccess,
  clearOrderList,
  createOrderFail,
  createOrderRequest,
  createOrderSuccess,
  createVideoEditOrderRequest,
  getOrderFail,
  getOrderListFail,
  getOrderListRequest,
  getOrderListSuccess,
  getOrderRequest,
  getOrderSuccess,
  initOrderFail,
  initOrderRequest,
  initOrderSuccess,
  saveOrderFail,
  saveOrderRequest,
  saveOrderSuccess, saveVideoEditOrderRequest,
} from './actions';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';
import OrderService from '../../../services/OrderService';
import {
  updateProjectStatusRequest
} from '../projects/actions';
import history from '../../../history';
import { getArticleCommentListRequest } from '../articleComments/actions';
import { getDefaultArticleCommentsParams } from '../../../views/projects/tab-activity/config';
import { transformVideoEditFormToOrderPayload } from '../../../utility/orders';


function* getOrderList({
  payload,
}: ReturnType<typeof getOrderListRequest>) {
  try {
    const list = yield apiCall(OrderService.list, payload);
    yield put(getOrderListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getOrderListFail());
  }
}

function* getOrder({ payload }: ReturnType<typeof getOrderRequest>) {
  try {
    const response = yield apiCall(OrderService.get, payload);
    yield put(getOrderSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getOrderFail());
  }
}

function* cancelOrder({ payload }: ReturnType<typeof cancelOrderRequest>) {
  try {
    yield apiCall(OrderService.cancel, payload.order_id, payload.notes);
    yield put(cancelOrderSuccess());
    yield put(getOrderRequest(payload.order_id));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(cancelOrderFail());
  }
}

function* saveOrder({ payload }: ReturnType<typeof saveOrderRequest>) {
  try {
    const response = yield apiCall(OrderService.save, payload.id, payload);
    yield put(saveOrderSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveOrderFail());
  }
}

function* saveVideoEditOrder({ payload }: ReturnType<typeof saveVideoEditOrderRequest>) {
  try {
    const preparedOrder = transformVideoEditFormToOrderPayload(payload);
    const response = yield apiCall(OrderService.save, payload.id as number, preparedOrder);

    yield put(saveOrderSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveOrderFail());
  }
}

function* createVideoEditOrder({ payload }: ReturnType<typeof createVideoEditOrderRequest>) {

  try {
    const response = yield apiCall(OrderService.create, transformVideoEditFormToOrderPayload(payload));
    yield put(createOrderSuccess(response));
    yield put(replace(`/dashboard/projects/${payload.project_id}/activity`));
    if (history.location.pathname.search('activity') > -1) {
      yield put(getArticleCommentListRequest(getDefaultArticleCommentsParams(payload.project_id)));
    }
    yield put(updateProjectStatusRequest(3));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(createOrderFail());
  }
}

function* createOrder({ payload }: ReturnType<typeof createOrderRequest>) {
  try {
    const response = yield apiCall(OrderService.create, payload); // test
    yield put(createOrderSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(createOrderFail());
  }
}

function* getTemplateOrder() {
  try {
    const response = yield apiCall(OrderService.template);
    yield put(initOrderSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(initOrderFail());
  }
}


function* clearList() {
  yield put(clearOrderList());
}

export default [
  takeLatest(getOrderListRequest.type, getOrderList),
  takeLatest(getOrderRequest.type, getOrder),
  takeLatest(cancelOrderRequest.type, cancelOrder),
  takeLatest(saveOrderRequest.type, saveOrder),
  takeLatest(saveVideoEditOrderRequest.type, saveVideoEditOrder),
  takeLatest(createOrderRequest.type, createOrder),
  takeLatest(createVideoEditOrderRequest.type, createVideoEditOrder),
  takeLatest(initOrderRequest.type, getTemplateOrder),
  takeLatest(logOut.type, clearList),
];
